import React from 'react';
import { makeStyles, Typography, fade } from '@material-ui/core';
import useCommonStyles from './useCommonStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.h5,
  },
  tertiary: {
    color: `${fade(theme.palette.neutrals[1], 0.5)}!important`,
  },
  inactive: {
    color: theme.palette.neutrals[6],
  },
}));

const H5 = ({
  children,
  center,
  right,
  white,
  secondary,
  tertiary,
  oneLine,
  className,
  inactive,
  ...props
}) => {
  const classes = useStyles();
  const common = useCommonStyles();

  return (
    <Typography
      classes={{ root: classes.root }}
      className={clsx({
        [common.center]: center,
        [common.right]: right,
        [common.white]: white || secondary,
        [common.wrapEllipsis]: oneLine,
        [classes.tertiary]: tertiary,
        [classes.inactive]: inactive,
        [className]: className.length > 0,
      })}
      {...props}
    >
      {children}
    </Typography>
  );
};

H5.defaultProps = {
  center: false,
  right: false,
  white: false,
  secondary: false,
  tertiary: false,
  oneLine: false,
  inactive: false,
  className: '',
};

H5.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  center: PropTypes.bool,
  right: PropTypes.bool,
  white: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  oneLine: PropTypes.bool,
  inactive: PropTypes.bool,
  className: PropTypes.string,
};

export default H5;
